import { createCRUDHook } from './createCRUDHook';
import {
  CallRailCall,
  CallRailCallsQueryParams,
  CallRailCallsResponse,
  UpdateCallRequest,
} from 'utils/models';
import { CALL_RAIL, CALLS } from './apiEndPoints';
import { prepareQueryParams } from 'utils';
interface CallRailCustomOperations {
  getCalls: (
    params?: CallRailCallsQueryParams,
  ) => Promise<CallRailCallsResponse>;
  updateCall: (
    callId: string,
    param: UpdateCallRequest,
  ) => Promise<CallRailCall>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  CallRailCall,
  CallRailCall[],
  CallRailCustomOperations
>({
  entityName: 'CallRail',
  endpoint: CALL_RAIL,

  customOperations: (auth) => ({
    getCalls: async (
      params?: CallRailCallsQueryParams,
    ): Promise<CallRailCallsResponse> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          CALL_RAIL + CALLS + `?/${prepareQueryParams(params)}`,
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    updateCall: async (
      callId: string,
      param: UpdateCallRequest,
    ): Promise<CallRailCall> => {
      try {
        const res = await auth.makeAuthenticatedPut(
          CALL_RAIL + CALLS + `/${callId}`,
          param,
        );

        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }),
});

export const CallRailContext = Context;
export const useCallRailManager = useManager;
export const useCallRail = useConsumer;
